/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
// eslint-disable-next-line no-unused-vars
import { MiddleViewport } from 'components/utility-component/wafer-map-widget/wafer-map/web-gl-utils/Enums';
// eslint-disable-next-line no-unused-vars
import { DieCountSummaryData, DieType } from 'components/utility-component/wafer-map-widget/wafer-map/web-gl-utils/Types';
import React from 'react';
import {
  Button, Col, Row, Spinner,
} from 'react-bootstrap';

type DieCountSummaryProps = {
  dieTypes: DieType[],
  onDieTypeDoubleClick: () => void,
  onDieTypeClick: (dieType: DieType | null) => void,
  currentDieTypeId: string | null,
  countSummary: DieCountSummaryData,
  onDefineDieTypesButtonClicked: () => void,
  middleViewport: MiddleViewport,
  isLoading: boolean,
  enabledDieTypes?: { [key: string]: boolean },
  onDieTypeToggle?: (dieTypeId: string, enabled: boolean) => void,
  removedDiesCount?: number,
  removedDiesPercentage?: number,
};

type DieCountSummaryState = {

};

export default class DieCountSummary extends React.Component<DieCountSummaryProps, DieCountSummaryState> {
  constructor(props: DieCountSummaryProps) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      dieTypes, onDieTypeDoubleClick, onDieTypeClick, currentDieTypeId, countSummary, onDefineDieTypesButtonClicked, middleViewport, isLoading,
    } = this.props;
    const isDieIncluded = (dt: DieType) => {
      if (typeof dt.isYielded === 'boolean') return dt.isYielded;
      const name = dt && dt.name ? dt.name.toLowerCase() : '';
      if (name.includes('probe') || name.includes('probed') || name.includes('not probed') || name.includes('not-probed') || name.includes('notprobed')) return true;
      if (/(partial|excluded|unidentified|unassigned|cropped)/.test(name)) return false;
      return true;
    };

    const includedTotalCount = dieTypes.reduce((acc: number, dt: DieType) => {
      const dieCount = countSummary.dieTypeCountInfo[dt.id] || 0;
      return acc + (isDieIncluded(dt) ? dieCount : 0);
    }, 0);
    // Additional summary calculations requested
    const sumOfDieTypeCounts = Object.values(countSummary.dieTypeCountInfo || {}).reduce((a: number, b: any) => a + (Number(b) || 0), 0);
    const deltaYield = countSummary.totalDieCount - includedTotalCount;
    const totalHardBinDies = dieTypes.reduce((acc: number, dt: DieType) => {
      const dieCount = countSummary.dieTypeCountInfo[dt.id] || 0;
      return acc + (dt.hardBinFlag ? dieCount : 0);
    }, 0);

    const totalSoftBinDies = dieTypes.reduce((acc: number, dt: DieType) => {
      const dieCount = countSummary.dieTypeCountInfo[dt.id] || 0;
      return acc + (dt.softBinFlag ? dieCount : 0);
    }, 0);

    const totalDiesCount = countSummary.totalDieCount || 0;
    const totalDiesPercentage = totalDiesCount !== 0
      ? Math.round((totalDiesCount / totalDiesCount) * 100 * 100) / 100
      : 0;
    const includedDiesPercentage = totalDiesCount !== 0
      ? Math.round((includedTotalCount / totalDiesCount) * 100 * 100) / 100
      : 0;
    const deltaYieldPercentage = totalDiesCount !== 0
      ? Math.round((deltaYield / totalDiesCount) * 100 * 100) / 100
      : 0;
    const totalHardBinDiesPercentage = totalDiesCount !== 0
      ? Math.round((totalHardBinDies / totalDiesCount) * 100 * 100) / 100
      : 0;
    const totalSoftBinDiesPercentage = totalDiesCount !== 0
      ? Math.round((totalSoftBinDies / totalDiesCount) * 100 * 100) / 100
      : 0;

    const homeDieType = dieTypes.find((dt: DieType) => dt.name && dt.name.toLowerCase() === 'home');
    const homeDieAssigned = homeDieType && (countSummary.dieTypeCountInfo[homeDieType.id] || 0) > 0;

    const removedNameRegex = /(removed|cropped|deleted)/i;
    const totalRemovedDies = typeof this.props.removedDiesCount === 'number'
      ? this.props.removedDiesCount
      : dieTypes.reduce((acc: number, dt: DieType) => {
        const dieCount = countSummary.dieTypeCountInfo[dt.id] || 0;
        return acc + (dt.name && removedNameRegex.test(dt.name) ? dieCount : 0);
      }, 0);

    const removedDiesPercentage = typeof this.props.removedDiesPercentage === 'number'
      ? this.props.removedDiesPercentage
      : totalDiesCount !== 0
        ? Math.round((totalRemovedDies / totalDiesCount) * 100 * 100) / 100
        : 0;

    return (
      <Col lg={2} className="wcm-die-count-summary-col">
        <h5 className="mt20 text-center no-selection-color">Die Count Summary</h5>
        <hr />
        <Row className="pl5 pt5 mb10">
          <Col lg={1} className="p0"><strong/></Col>
          <Col lg={4} className="p0" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}><strong>Name</strong></Col>
          <Col lg={3} className="p0 text-center"><strong>Count</strong></Col>
          <Col lg={2} className="p0 text-center"><strong>Include in Yield/Die Count</strong></Col>
          <Col lg={2} className="p0 text-center"><strong>%age</strong></Col>
        </Row>
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '430px' }}>
            <Spinner animation="border" />
          </div>
        ) : (
          <div>
            <div>
              {dieTypes.map((dieType: DieType, index: number) => {
                const enabled = this.props.enabledDieTypes && this.props.enabledDieTypes[dieType.id] !== undefined
                  ? this.props.enabledDieTypes[dieType.id]
                  : true;
                return (
                  <Row
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${index}${dieType.name}`}
                    className="pl5 pt5 mb10"
                    role={enabled ? 'button' : undefined}
                    onDoubleClick={enabled ? onDieTypeDoubleClick : undefined}
                    onClick={() => { if (enabled) onDieTypeClick(dieType); }}
                    style={{ fontSize: '12px', backgroundColor: dieType.id === currentDieTypeId ? '#ddd' : '#fff', opacity: enabled ? 1 : 0.5, cursor: enabled ? 'pointer' : 'default' }}
                  >
                    <Col lg={1} className="p0" style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type="checkbox"
                        checked={enabled}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          this.props.onDieTypeToggle?.(dieType.id, e.target.checked);
                        }}
                      />
                    </Col>
                    <Col lg={4} className="p0" style={{ wordWrap: 'break-word', overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                      <span className="h10 mr5 w20" style={{ backgroundColor: (dieType.color), display: 'inline-block', flexShrink: 0, verticalAlign: 'top' }} />
                      <span style={{ display: 'inline-block', maxWidth: 'calc(100% - 30px)', wordWrap: 'break-word', overflowWrap: 'break-word', wordBreak: 'break-word', verticalAlign: 'top' }}>{dieType.name}</span>
                    </Col>
                    <Col lg={3} className="p0 text-center">{countSummary.dieTypeCountInfo[dieType.id] || 0}</Col>
                    <Col lg={2} className="p0 text-center">{isDieIncluded(dieType) ? 'Yes' : 'No'}</Col>
                    <Col lg={2} className="p0 text-center">
                      {countSummary.totalDieCount !== 0 && countSummary.dieTypeCountInfo[dieType.id] !== undefined && countSummary.dieTypeCountInfo[dieType.id] !== null
                        ? Math.round((countSummary.dieTypeCountInfo[dieType.id] / countSummary.totalDieCount) * 100 * 100) / 100
                        : 0}
                      {' '}
                      %
                    </Col>
                  </Row>
                );
              })}
            </div>
            <hr />
            <Row
              className="pl5 pt5"
              style={{ fontSize: '12px', backgroundColor: currentDieTypeId === null ? '#ddd' : '#fff' }}
            >
              <Col lg={5} className="p0"><strong>Total Dies Count</strong></Col>
              <Col lg={3} className="p0 text-center">{countSummary.totalDieCount}</Col>
              <Col lg={2} className="p0" />
              <Col lg={2} className="p0 text-center">{totalDiesPercentage} %</Col>
            </Row>
            
            <Row className="pl5 pt5" style={{ fontSize: '12px' }}>
              <Col lg={5} className="p0"><strong>Total Dies Included in Yield/Die Count</strong></Col>
              <Col lg={3} className="p0 text-center">{includedTotalCount}</Col>
              <Col lg={2} className="p0" />
              <Col lg={2} className="p0 text-center">{includedDiesPercentage} %</Col>
            </Row>

            <Row className="pl5 pt5" style={{ fontSize: '12px' }}>
              <Col lg={5} className="p0"><strong>Delta Yield</strong></Col>
              <Col lg={3} className="p0 text-center">{deltaYield}</Col>
              <Col lg={2} className="p0" />
              <Col lg={2} className="p0 text-center">{deltaYieldPercentage} %</Col>
            </Row>

            <Row className="pl5 pt5" style={{ fontSize: '12px' }}>
              <Col lg={5} className="p0"><strong>Total Hard Bin Dies</strong></Col>
              <Col lg={3} className="p0 text-center">{totalHardBinDies}</Col>
              <Col lg={2} className="p0" />
              <Col lg={2} className="p0 text-center">{totalHardBinDiesPercentage} %</Col>
            </Row>

            <Row className="pl5 pt5" style={{ fontSize: '12px' }}>
              <Col lg={5} className="p0"><strong>Total Soft Bin Dies</strong></Col>
              <Col lg={3} className="p0 text-center">{totalSoftBinDies}</Col>
              <Col lg={2} className="p0" />
              <Col lg={2} className="p0 text-center">{totalSoftBinDiesPercentage} %</Col>
            </Row>

            <Row className="pl5 pt5" style={{ fontSize: '12px' }}>
              <Col lg={5} className="p0"><strong>Home Die Assigned</strong></Col>
              <Col lg={3} className="p0" />
              <Col lg={2} className="p0">{homeDieAssigned ? 'Yes' : 'No'}</Col>
              <Col lg={2} className="p0" />
            </Row>

            <Row className="pl5 pt5" style={{ fontSize: '12px' }}>
              <Col lg={5} className="p0"><strong>Total Removed Dies</strong></Col>
              <Col lg={3} className="p0 text-center">{totalRemovedDies}</Col>
              <Col lg={2} className="p0" />
              <Col lg={2} className="p0 text-center">{removedDiesPercentage} %</Col>
            </Row>

            <hr />
            <Button
              onClick={onDefineDieTypesButtonClicked}
              size="sm"
              variant="primary"
              className="mt10 mb30"
            >
              {middleViewport === MiddleViewport.WAFER ? 'Define Die Types' : 'Device Map' }
            </Button>
          </div>
        )}
      </Col>

    );
  }
}
